<template>
  <v-container fluid grid-list-md id="page-body" :class="{'px-0': $vuetify.breakpoint.smAndDown}">

    <v-layout row>
      <v-flex xs12 sm6 md4 lg3>
        <v-container grid-list-md class="data-card-container" :class="{'px-0': $vuetify.breakpoint.smAndDown}">
          <v-card class="card stocks-card item ma-2" :elevation="2">
            <v-card-title>
              Stocks
            </v-card-title>
            <v-card-text>
            <v-flex text-xs-left
                class="ticker-item"
                v-for="(item, name, index) in tickers"
                :key="index"
                >
                <div v-if="index == 0" class="column-heading">
                  <div class="header">Symbol</div>
                  <div class="header right">Price</div>
                  <div class="header right">Change</div>
                  <div class="header right">% Chg</div>
                </div>
                <div v-for="(quote, idx2) in item"
                    :key="idx2"
                    :class="getClass(quote.change)">
                    <div class="data symbol">
                      <a :href="getTickerUrl(quote.symbol)" target="_blank" rel="noopener noreferrer">{{ quote.symbol }}</a>
                    </div>
                    <div class="data latestPrice right">{{ quote.latestPrice }}</div>
                    <div class="data change right">{{ quote.change }}</div>
                    <div class="data changePercent right">{{ (quote.changePercent * 100).toFixed(2) }}%</div>
                </div>
            </v-flex>
            </v-card-text>

            <v-card-title>
              Crypto
            </v-card-title>
            <v-card-text>
                <v-flex text-xs-left
                    class="ticker-item"
                    >
                    <div class="column-heading">
                      <div class="header">Symbol</div>
                      <div class="header right">Price</div>
                    </div>
                    <div class="ticker-quote">
                        <div class="data symbol">
                          <a :href="getCryptoUrl(bitcoin.symbol)" target="_blank" rel="noopener noreferrer">{{ bitcoin.symbol }}</a>
                        </div>
                        <div class="data latestPrice right">{{ bitcoin.price }}</div>
                    </div>
                    <div class="ticker-quote">
                        <div class="data symbol">
                          <a :href="getCryptoUrl(etherium.symbol)" target="_blank" rel="noopener noreferrer">{{ etherium.symbol }}</a>
                        </div>
                        <div class="data latestPrice right">{{ etherium.price }}</div>
                    </div>
                </v-flex>
            </v-card-text>
            
          </v-card>
        </v-container>
      </v-flex>
      <v-flex xs12 sm6 md4 lg3>
        <rsscard newsSource="marketwatch" displayTitle="" displayThumb="true" className="card-with-image" rssImage="https://mw2.wsj.net/mw5/content/logos/mw_logo_onDark.svg"></rsscard>
      </v-flex>
      <v-flex xs12 sm6 md4 lg3>
        <rsscard newsSource="cnbc-finance" displayTitle="" displayThumb="true" className="card-with-image" rssImage="https://static-redesign.cnbcfm.com/dist/7821ea3cb72f88388591.svg"></rsscard>
      </v-flex>
      <v-flex xs12 sm6 md4 lg3>
        <rsscard newsSource="investopedia" displayTitle="" displayThumb="true" className="card-with-image" rssImage=""></rsscard>
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex xs12>
        <newscards newsSource="cnbc"></newscards>
        <newscards newsSource="fortune"></newscards>
        <newscards newsSource="business-insider"></newscards>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import stockApi from '../services/ApiService'

export default {
  name: 'Finance',
  data () {
    return {
      tickers: [],
      bitcoin: [],
      etherium: []
    }
  },
  methods: {
    fetchStockQuotes () {

      var tickerList = ''

      stockApi.fetchDataFile ('stocks-data.json')
      .then(response => {
        if (Object.keys(response).length) {
          tickerList = response.tickerList

          stockApi.fetchStockQuotes(tickerList)
            .then(response => {
              if (Object.keys(response).length) {
                this.tickers = response
                this.loading = false
                this.noData = false
              } else {
                this.noData = true
                this.loading = false
              }
            })
            .catch(error => {
              // eslint-disable-next-line no-console
              console.log(error)
            })
            
        }
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log(error)
      })

    },
    fetchCryptoQuotes () {
        //btcusd, ethusd
        stockApi.fetchCryptoQuote('btcusd')
        .then(response => {
          if (Object.keys(response).length) {
            this.bitcoin = response
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error)
        })

        stockApi.fetchCryptoQuote('ethusd')
        .then(response => {
          if (Object.keys(response).length) {
            this.etherium = response
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error)
        })
    },
    getClass (changeValue) {
        var className = "ticker-quote"
        if (changeValue > 0) {
            className += " up"
        }
        else if (changeValue < 0) {
            className += " down"
        }

        return className
    },
    getTickerUrl (ticker) {
      var tickerUrl = "https://www.marketwatch.com/investing/stock/" + ticker
      return tickerUrl
    },
    getCryptoUrl (ticker) {
      var cryptoUrl = 'https://www.marketwatch.com/investing/cryptocurrency/' + ticker
      return cryptoUrl
    }
  },
  mounted () {
    this.fetchStockQuotes(),
    this.fetchCryptoQuotes()
  },
  computed: {
    flex () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 12
        case 'sm': return 6
        case 'md': return 4
        case 'lg': return 3
        case 'xl': return 3
        default: return 3
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-card__title {
    padding-left: 16px;
    padding-bottom: 0;
  }

  .ticker-item {
    padding: 1px !important;
  }

  .column-heading, .ticker-quote {
    display: flex;

    .header {
      flex: 0 0 25%;
      font-weight: 700;

      &.right {
        text-align: right;
      }
    }

    .data {
      flex: 0 0 25%;

      &.right {
        text-align: right;
      }
    }

    &.up {
      color: #093;
    }
    &.down {
      color: #ff333a;
    }
  }
</style>
